export const environment = {
  production: false,
  DO_URL: 'https://lmccredit.ca/api',
  isDemo: false,
  idleTime: 15 * 60 * 1000,
  backgroundColor: '#fafafa',

  version: 'v4.1.2',
};
